export const ADMIN_DEBUGGER_LS_KEY = 'debuggerEnabled';

export const SIDEBAR_MINIMIZED_LS_KEY = 'sidebarMinimized';
